import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { TableCell, Fab, TableRow } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ExceptionListStyles from "../styleComponent";
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.grey[100],
    },
  },
}))(TableRow);

export default function Row({ row, sno, exceptionListCols, editRow }) {
  const colCodes = Object.keys(exceptionListCols);
  const classes = ExceptionListStyles();

  return (
    <React.Fragment>
      <StyledTableRow className={classes.root}>
        <TableCell component="th" scope="row" align="left">
          {sno}
        </TableCell>
        {exceptionListCols.map((el) => {
          return (
            <TableCell align="left" key={el.code}>
              {String(row[el.code] === undefined ? "" : row[el.code])}
            </TableCell>
          );
        })}
        <TableCell component="th" scope="row" align="left">
          <Fab
            color="default"
            aria-label="edit"
            size="small"
            variant="extended"
            disableRipple={true}
            onClick={(e) => editRow(e, row)}
            className={classes.margin}
          >
            <EditIcon color="primary" />
          </Fab>
        </TableCell>
      </StyledTableRow>
    </React.Fragment>
  );
}
